@if (current$ | async; as item) {
  <button
    class="button"
  [class.active]="
    !(isDisabled(item) ||
    ((isInEditMode$ | async) && item.active && disabled !== true))
  "
  [disabled]="
    isDisabled(item) ||
    ((isInEditMode$ | async) && item.active && disabled !== true)
  "
    (click)="toggle(item)"
    >
    {{ 'organization.delete' | cxTranslate }}
  </button>
}
